import { useRef } from 'react';

export const useIndexGenerator = (initial: number = 0, step: number = 1) => {
  const index = useRef(initial);
  return () => {
    const generated = index.current;
    index.current += step;
    return generated;
  };
};
